// extracted by mini-css-extract-plugin
export default {"form":"MonitorBatchOperationsForm_form__SpANP","batchEmpty":"MonitorBatchOperationsForm_batchEmpty__zKrAQ","hint":"MonitorBatchOperationsForm_hint__esCLv"};